import { marked } from 'marked'

const closeOverlay = (
  title: string,
  copy: string,
  setSubmitResonse: Function,
  disabled?: boolean,
) => {
  if (window && window.location !== window.parent.location && !disabled) {
    const message = {
      id: 'gb-iframe-close',
      data: {
        title,
        copy: copy
          ? (marked.parseInline(copy) as string).replace(/<a /g, '<a style="color: white; text-decoration: underline;" ')
          : '',
      },
    }

    window.parent.postMessage(message, '*')
    // eslint-disable-next-line no-console
    console.log('[GB] Close overlay message sent:', message)
  } else {
    setSubmitResonse(`${title} ${copy || ''}`)
  }
}

export default closeOverlay
